import { Grid } from '@mui/material';
import { RouteBreadcrumb } from './RouteBreadcrumb';
import { SubBar } from './SubBar';
import { useStyles } from './styles/BreadcrumbSubBar.styles';

export const BreadcrumbSubBar = ({ children }: { children?: React.ReactNode }) => {
    const classes = useStyles();

    return (
        <SubBar>
            <Grid
                display={'flex'}
                flex={1}
                alignItems={'center'}
                justifyContent={'flex-start'}
                className={classes.breadcrumbContainer}>
                <RouteBreadcrumb />
                {children}
            </Grid>
        </SubBar>
    );
};
